import { EntitiesList } from 'components/eventView/entities/EntitiesList';
import { EFonts } from 'libs/styles/styling';
import { orderBy, sortBy } from 'lodash';
import { useContext } from 'react';
import { CtxEventView } from 'session/ctxEventView';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    entityId: string;
    className?: string;
}

export const EntitiesSectionView = (props: Props): JSX.Element => {
    const ctxEventView = useContext(CtxEventView);

    const entityState = ctxEventView.entityStates[props.entityId];

    const unsortedCategories = ctxEventView.otherEntityDefinitions.find(
        (e) => e.id === props.entityId
    ).categories;
    const filteredCategories = unsortedCategories.filter((e) =>
        entityState.filterIds ? entityState.filterIds.includes(e.categoryId) : true
    );
    const categories = sortBy(filteredCategories, (e) => e.orderIndex);

    const notInAnyCategories = orderBy(
        entityState.visible.filter((e) => e.categoryIds.length === 0),
        (e) => e.title?.toLowerCase(),
        'asc'
    );

    return (
        <S_EntitiesSectionView className={props.className}>
            {categories.map((category) => {
                const itemsInSection = entityState.visible.filter((e) =>
                    e.categoryIds.includes(category.categoryId)
                );
                if (itemsInSection.length === 0) {
                    return null;
                }
                const ordered = orderBy(itemsInSection, (e) => e.title?.toLowerCase(), 'asc');
                return (
                    <S_Section key={category.categoryId}>
                        <S_Title $large={ctxEventView.isWide}>{category.title}</S_Title>
                        <EntitiesList entityId={props.entityId} items={ordered} />
                    </S_Section>
                );
            })}

            {notInAnyCategories.length > 0 &&
                entityState.filterIds &&
                entityState.filterIds.length === 0 && (
                    <S_Section>
                        <S_Title $large={ctxEventView.isWide}>{Localization.OTHER_ITEMS}</S_Title>
                        <EntitiesList entityId={props.entityId} items={notInAnyCategories} />
                    </S_Section>
                )}
        </S_EntitiesSectionView>
    );
};

const S_EntitiesSectionView = styled.div``;

const S_Section = styled.div`
    margin-bottom: 40px;
`;

const S_Title = styled.div<{ $large: boolean }>`
    margin-bottom: 16px;
    font-family: ${(props) => (props.$large ? EFonts.Bold : EFonts.Medium)};
    font-size: ${(props) => (props.$large ? '22px' : '16px')};
`;
